import React from 'react';
import DatePickerDropdownField from 'views/DatePickerDropdownField.js';

const DateRangePickerField = ({ onChange, value }) => {

    const onDateChange = (key, date) => {

        // notify subscriber of data change
        if(typeof(onChange) === 'function') {
            onChange({
                end_date: key === 'end_date' ? date : value?.end_date,
                start_date: key === 'start_date' ? date : value?.start_date
            });
        }
    }

    return (
        <div style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        }}>
            <DatePickerDropdownField
            onChange={onDateChange.bind(this, 'start_date')}
            style={{
                marginBottom: 8,
            }}
            value={value?.start_date} />
            <DatePickerDropdownField
            onChange={onDateChange.bind(this, 'end_date')}
            value={value?.end_date} />
        </div>
    )
}
export default DateRangePickerField;
